import Vue from 'vue'
import VueRouter from 'vue-router'
import eventBus from '../utils/eventbus'

import activityRoutes from './activity'
import deprecatedRoutes from './deprecated.js'
import docsRoutes from './docs'
import downloadRoutes from './download'

import { isHistoryModeVersion, migrateRouteUrl } from '@/utils/router-mode.js'
import { registerTaRoutePageView } from '@/utils/ta-page-view.js'

// P1_Boys ↓
const MyLevel = () => import(/* webpackChunkName:"chunk-mylevel" */ '../views/P1_Boys/MyLevel/index.vue')
const MyProps = () => import(/* webpackChunkName:"chunk-myprops" */ '../views/P1_Boys/MyProps/index.vue')
const PayNext = () => import(/* webpackChunkName:"chunk-pay" */ '../views/P1_Boys/PayNext/index.vue')
const PayStore = () => import(/* webpackChunkName:"chunk-pay" */ '../views/P1_Boys/PayStore/index.vue')
const PayStoreEcho = () => import(/* webpackChunkName:"chunk-echopay" */ '../views/P1_Boys/PayStoreEcho')
const PayCode = () => import(/* webpackChunkName:"chunk-paycode" */ '../views/P1_Boys/PayCode/index.vue')
const PayResult = () => import(/* webpackChunkName:"chunk-payres" */ '../views/P1_Boys/PayResult/index.vue')
const PayThirdBack = () => import(/* webpackChunkName:"chunk-payres" */ '../views/P1_Boys/PayThirdBack/index.vue')
const SignIn = () => import(/* webpackChunkName:"chunk-signin" */ '../views/P1_Boys/SignIn/index.vue')
// P1_Boys ↑

// P1_Girls ↓
const HostessCenter = () => import(/* webpackChunkName:"chunk-hostesscenter" */ '../views/P1_Girls/HostessCenter')

const HostessIncomeRank = () => import(/* webpackChunkName:"chunk-hostessincomerank" */ '../views/P1_Girls/HostessIncomeRank/index.vue')
const HostessIncomeRankRule = () => import(/* webpackChunkName:"chunk-hostessincomerank" */ '../views/P1_Girls/HostessIncomeRank/rule.vue')

const HostessRank = () => import(/* webpackChunkName:"chunk-hostessrank" */ '../views/P1_Girls/HostessRank/index.vue')
const HostessRankRule = () => import(/* webpackChunkName:"chunk-hostessrank" */ '../views/P1_Girls/HostessRank/rule.vue')

const HostessTasks = () => import(/* webpackChunkName:"chunk-hostessTasks" */ '../views/P1_Girls/HostessTasks')

const MyBeans = () => import(/* webpackChunkName:"chunk-mybeans" */ '../views/P1_Girls/MyBeans')
const MyBeansDetails = () => import(/* webpackChunkName:"chunk-mybeans" */ '../views/P1_Girls/MyBeans/MyBeansDetails.vue')
const MyBeansReport = () => import(/* webpackChunkName:"chunk-mybeans" */ '../views/P1_Girls/MyBeans/Report.vue')
const ReportDetails = () => import(/* webpackChunkName:"chunk-mybeans" */ '../views/P1_Girls/MyBeans/ReportDetails.vue')

const Withdrawal = () => import(/* webpackChunkName:"chunk-withdrawal" */ '../views/P1_Girls/Withdrawal')
const instantPayment = () => import(/* webpackChunkName:"chunk-withdrawalpayment" */ '../views/P1_Girls/Withdrawal/instantPayment.vue')
const WithdrawalAccount = () => import(/* webpackChunkName:"chunk-withdrawalaccount" */ '../views/P1_Girls/WithdrawalAccount')
const BindWithdrawal = () => import(/* webpackChunkName:"chunk-bindwithdrawal" */ '../views/P1_Girls/WithdrawalBind')
const WithdrawalDetailsStatus = () => import(/* webpackChunkName:"chunk-withdrawaldetail" */ '../views/P1_Girls/WithdrawalDetails/detailInfo.vue')
const WithdrawalDetails = () => import(/* webpackChunkName:"chunk-withdrawaldetail" */ '../views/P1_Girls/WithdrawalDetails/detailList.vue')
// P1_Girls ↑

// P2 ↓
const AgentProfile = () => import(/* webpackChunkName:"chunk-invite" */ '../views/P2_Page/AgentProfile/index.vue')
const BecomeAgent = () => import(/* webpackChunkName:"chunk-becomeagent" */ '../views/P2_Page/BecomeAgent')
const DynamicPolicy = () => import(/* webpackChunkName:"chunk-invite" */ '../views/P2_Page/DynamicPolicy/index.vue')

const FriendshipLevel = () => import(/* webpackChunkName:"chunk-friendship" */ '../views/P2_Page/FriendshipLevel')
const FriendshipLevelRule = () => import(/* webpackChunkName:"chunk-friendship" */ '../views/P2_Page/FriendshipLevel/intimateRule.vue')

const Invite = () => import(/* webpackChunkName:"chunk-invite" */ '../views/P2_Page/Invite/index.vue')
const InviteVRules = () => import(/* webpackChunkName:"chunk-invite" */ '../views/P2_Page/Invite/Sub_Page/Rules.vue')
const InviteSubAgentNew = () => import(/* webpackChunkName:"chunk-invite" */ '../views/P2_Page/Invite/components/SubAgent/NewSubAgentPage.vue')
const InviteSubAgentPerformance = () =>
  import(/* webpackChunkName:"chunk-invite" */ '../views/P2_Page/Invite/components/SubAgent/SubAgentPerformancePage.vue')
const InviteHistory = () => import(/* webpackChunkName:"chunk-invite" */ '../views/P2_Page/InviteHistory')

const SevenKeepSignin = () => import(/* webpackChunkName:"chunk-sevenkeepsignin" */ '../views/P2_Page/SevenKeepSignin')
const SevenKeepSigninRule = () => import(/* webpackChunkName:"chunk-sevenkeepsignin" */ '../views/P2_Page/SevenKeepSignin/rules')

const Violation = () => import(/* webpackChunkName:"chunk-violation" */ '../views/P2_Page/Violation')
// P2 ↑

// P4 ↓
const RulesHostess = () => import(/* webpackChunkName:"chunk-allrules" */ '../views/P4_Page/BaseRules/rules-hostess.vue')
const RulesUser = () => import(/* webpackChunkName:"chunk-allrules" */ '../views/P4_Page/BaseRules/rules-user.vue')
const EarningRules = () => import(/* webpackChunkName:"chunk-allrules" */ '../views/P4_Page/EarningRules')
const FAQ = () => import(/* webpackChunkName:"chunk-allrules" */ '../views/P4_Page/FAQ')
const LevelRatio = () => import(/* webpackChunkName:"chunk-allrules" */ '../views/P4_Page/LevelRatio')
const RealVerifyQA = () => import(/* webpackChunkName:"chunk-allrules" */ '../views/P4_Page/RealVerifyQA/index.vue')
const RealVerifyRulesMale = () => import(/* webpackChunkName:"chunk-allrules" */ '../views/P4_Page/RealVerifyRules/male.vue')
const RealVerifyRulesFemale = () => import(/* webpackChunkName:"chunk-allrules" */ '../views/P4_Page/RealVerifyRules/female.vue')
const NotFound = () => import(/* webpackChunkName:"chunk-notfound" */ '../views/P4_Page/NotFound/index.vue')
// P4 ↑

if (!VueRouter.install.installed) {
  Vue.use(VueRouter)
}

// prettier-ignore
const routes = [
  // P1_Boys
  {
    path: '/my-level', name: 'my-level', component: MyLevel
  },
  {
    path: '/my-props', name: 'my-props', component: MyProps
  },
  {
    path: '/pay', name: 'pay', component: PayNext
  },
  {
    path: '/echo-pay', name: 'echo-pay', component: PayNext
  },
  {
    path: '/pay-v2', name: 'pay-v2', component: PayNext
  },
  {
    path: '/buy-coins', name: 'buy-coins', component: PayStore
  },
  {
    path: '/echo-pay-store', name: 'echo-pay-store', component: PayStoreEcho
  },
  {
    path: '/pay-code', name: 'pay-code', component: PayCode
  },
  // todo pay-result 客户端未用此路由；h5端未用此路由；服务端未用此路由
  {
    path: '/pay-result', name: 'pay-result', component: PayResult
  },
  {
    path: '/pay-third-back', name: 'pay-third-back', component: PayThirdBack
  },
  {
    path: '/male-signin', name: 'pay-signin', component: SignIn
  },
  // P1_Girls
  {
    path: '/hostess-center', name: 'hostess-center', component: HostessCenter
  },
  {
    path: '/hostess-income-rank', name: 'hostess-income-rank', component: HostessIncomeRank
  },
  {
    path: '/hostess-income-rank-rules', name: 'hostess-income-rank-rules', component: HostessIncomeRankRule
  },
  {
    path: '/hostess-rank', name: 'hostess-rank', component: HostessRank
  },
  {
    path: '/hostess-rank-rules', name: 'hostess-rank-rules', component: HostessRankRule
  },
  {
    path: '/hostess-tasks', name: 'hostess-tasks', component: HostessTasks
  },
  {
    path: '/my-beans', name: 'my-beans', component: MyBeans
  },
  {
    path: '/income/details', name: 'income-details', component: MyBeansDetails
  },
  {
    path: '/income/report', name: 'income-report', component: MyBeansReport
  },
  {
    path: '/income/report/details', name: 'income-report-details', component: ReportDetails
  },
  {
    path: '/withdrawal', name: 'withdrawal', component: Withdrawal
  },
  {
    path: '/instant-payment', name: 'instant-payment', component: instantPayment
  },
  {
    path: '/withdrawal-account', name: 'withdrawal-account', component: WithdrawalAccount
  },
  {
    path: '/bind-withdrawal', name: 'bind-withdrawal', component: BindWithdrawal
  },
  {
    path: '/withdrawal-details', name: 'withdrawal-details', component: WithdrawalDetails
  },
  {
    path: '/withdrawal-details-status', name: 'withdrawal-details-status', component: WithdrawalDetailsStatus
  },
  // P2
  {
    path: '/agent-profile', name: 'agent-profile', component: AgentProfile
  },
  {
    path: '/become-agent', name: 'become-agent', component: BecomeAgent
  },
  {
    path: '/invite-dypolicy', name: 'invite-dypolicy', component: DynamicPolicy
  },
  {
    path: '/demo/invite-dypolicy', name: 'invite-dypolicy-demo', component: DynamicPolicy
  },
  {
    path: '/friendship-level', name: 'friendship-level', component: FriendshipLevel
  },
  {
    path: '/friendship-level-rule', name: 'friendship-level-rule', component: FriendshipLevelRule
  },
  {
    path: '/invite', name: 'invite', component: Invite, meta: { keepAlive: true }
  },
  {
    path: '/invite-rules', name: 'invite-rules', component: InviteVRules
  },
  {
    path: '/invite-sub-agent-new', name: 'invite-sub-agent-new', component: InviteSubAgentNew
  },
  {
    path: '/invite-sub-agent-performance', name: 'invite-sub-agent-performance', component: InviteSubAgentPerformance
  },
  {
    path: '/invite-history', name: 'invite-history', component: InviteHistory
  },
  {
    path: '/seven-keep-signin', name: 'seven-keep-signin', component: SevenKeepSignin
  },
  {
    path: '/seven-keep-signin-rules', name: 'seven-keep-signin-rules', component: SevenKeepSigninRule
  },
  {
    path: '/violation-details', name: 'violation-details', component: Violation
  },
  // P4
  {
    path: '/rules', name: 'rules-female', component: RulesHostess
  },
  {
    path: '/rules-male', name: 'rules-male', component: RulesUser
  },
  {
    path: '/earning-rules', name: 'earning-rules', component: EarningRules
  },
  {
    path: '/faq', name: 'faq', component: FAQ
  },
  {
    path: '/level-ratio', name: 'level-ratio', component: LevelRatio
  },
  {
    path: '/real-verify-qa', name: 'real-verify-qa', component: RealVerifyQA
  },
  {
    path: '/real-verify-rules-male', name: 'real-verify-rules-male', component: RealVerifyRulesMale
  },
  {
    path: '/real-verify-rules-female', name: 'real-verify-rules-female', component: RealVerifyRulesFemale
  },
  // other
  ...activityRoutes,
  ...deprecatedRoutes,
  ...docsRoutes,
  ...downloadRoutes,
  // 为了给官网的默认路由留一个位置；避免 404 页面显示在官网首页
  { path: '/', redirect: '/home' },
  // 404 页面
  { path: '*', name: 'not-found', component: NotFound }
]

// 代理中心二级页面
const limitPathsToInvite = [
  '/agent-profile',
  '/invite-dypolicy',
  '/invite-rules',
  '/violation-details',
  '/invite-sub-agent-new',
  '/invite-sub-agent-performance',
  '/invite-history',
  '/withdrawal',
  '/sub-agent-event',
]

const isHistoryMode = isHistoryModeVersion()

migrateRouteUrl(isHistoryMode)

const router = new VueRouter({
  mode: isHistoryMode ? 'history' : 'hash',
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.path === '/invite' && limitPathsToInvite.includes(from.path)) {
    eventBus.$emit('refreshInvitePage')
  }

  window.scrollTo(0, 0)
  next()
})

registerTaRoutePageView(router, isHistoryMode)

// 路由
export default router
